<template>
    <div class="widgetPanel" :class="{'betSlip': selectedTab == 'betTab', 'betList': selectedTab == 'betSlipTab', 'active': selectedBetTab, 'collapsed': !selectedBetTab}" v-global-click-event="closeTab">
      <div class="menu-wrap scroll-fixed-bg relative-position bet_history" :class="{'item-wrap': oddSelected||openBetForm}" >
          <div class="menu-item menu-top menu-border item justify-start" v-if="tvIconFlag" @click="openLivetv()" :class="{'active':liveSchedule}" :style="{display: selectedTab == 'betSlipTab' ? 'none' : ''}">
            <div class="schedule-icon"></div>
            <div class="col">{{ lang.LivetvLang['LIVETV.SCHEDULE2'] }}</div>
            <!-- <span class="bet-count">0</span> -->
          </div>
        </div>
        <div class="glyphIcon icon-widgetCollapse" title="Collapse the Widget Panel"  @click="closeTab()"></div>
          <div class="menu-wrap scroll-fixed-bg relative-position bet_history">
          <div class="menu-item menu-top menu-border item justify-start" @click="changeTab('betSlipTab')"  v-if="selectedTab != 'betSlipTab'">
            <div class="hot-icon"></div>
            <div class="col">{{ betLang['BETTING.MY_BETS'] }}</div>
            <span class="bet-count">{{ ttlBetAmount }}</span>
          </div>

          <div class="menu-item menu-top item-bet menu-border" v-if="(!oddSelected && showbetformMenu)" @click="toggleBetForm()">
            <span class="text">{{ betLang['BETTING.MY_BETS'] }}</span>
            <span class="bet-count">{{betForm.length}}</span>
          </div>
        </div>

        <!-- BETTING -->
        <div class="bet-scroll-header" v-if="oddSelected || openBetForm">
          <div class="vrow bet-back-btn yb-flex-between">
            <div class="col yb-flex cursor-pointer" @click="backMenu()">
              <i aria-hidden="true" role="presentation" class="q-icon icon-back c-icon" style="font-size: 14px;"></i>
              <div class="back-text ellipsis">{{ betLang['BETTING.LBL_BACKTOMENU'] }}</div>
            </div>

            <div class="bet-series-box" v-if="hasParlay && !isParlayTab && this.selectedBettype.betTypId != '6'">
              <span class="bet-series-text" :class="{'actions':isMulp}">{{ betLang['BETTING.LBL_PARLAY'] }}</span>
              <div class="bet-series-switch" :class="{'actions':isMulp}" @click="updateParlay(true)">
                <div class="bet-series-ok" :class="{'actions':isMulp}"></div>
              </div>
            </div>
            <div class="col-auto bet-series yb-flex-between bet-cursor-none" v-else>
              <span class="series_style" v-if="isMulp">{{ betLang['BETTING.LBL_PARLAY'] }}</span>
              <span v-if="!isMulp">{{ betLang['BETTING.LBL_SINGLE'] }}</span>
              <span>+</span>
            </div>
          </div>
          <div class="vrow bg-white"></div>
          <div class="bet-header-position"></div>
        </div>

        <!-- MY BET-->
        <div class="bet-scroll-header" v-if="selectedTab == 'betSlipTab'"> 
          <div class="vrow bet-back-btn yb-flex-between">
            <div class="col yb-flex cursor-pointer" @click="backMenu()">
            <!-- <div class="col yb-flex cursor-pointer" @click="changeTab('betTab')"> -->
              <i aria-hidden="true" role="presentation" class="q-icon icon-back c-icon" style="font-size: 14px;"></i>
              <div class="back-text ellipsis">{{ betLang['BETTING.LBL_BACKTOMENU'] }}</div>
            </div>
          </div>
          <div class="vrow bg-white"></div>
          <div class="bet-header-position"></div>
          <div data-v-fec66818="" class="full-width bet-type yb-fontsize13">
            <div data-v-fec66818="" class="row bet-record-item cursor-pointer">
              <div data-v-fec66818="" class="col text-center ellipsis"  @click="changeBetSlipType(1)" :class="{'active': selectedBetListType == 1 && !pendingFlag}">{{ betLang['BETTING.LBL_BETS'] }}</div>
              <div data-v-fec66818="" class="col text-center ellipsis"  @click="changeBetSlipType(2)" :class="{'active': selectedBetListType == 2 || pendingFlag}">{{ betLang['BETTING.LBL_WAITING'] }}</div>
              <div data-v-fec66818="" class="col-auto menu-tab-line">
                <div data-v-fec66818="" class="line"></div>
              </div>
              <div data-v-fec66818="" class="col text-center ellipsis"  @click="changeBetSlipType(3)" :class="{'active': selectedBetListType == 3 && !pendingFlag}">{{ betLang['BETTING.LBL_VOID'] }}</div>
            </div>
          </div>
        </div>
        

        <!-- <div class="contentArea"> -->


          <!-- <div class="nav-widgetPanel twoColum" v-if="selectedTab == 'betTab'">
            <div class="item  icon-betSlip-single" :title="betLang['BETTING.LBL_SINGLE_BET']" :class="{'active': !isMulp}">
              <span class="itemContent">
                <span class="text">{{betLang['BETTING.LBL_SINGLE_BET']}}</span>
              </span>
            </div>
            <div class="item icon-betSlip-parlay" :title="betLang['BETTING.LBL_PARLAY']" :class="{'active': isMulp && parlaySelected!=null }">
              <span class="itemContent">
                <span class="text">{{ betLang['BETTING.LBL_PARLAY'] }}</span>
                <div class="alertArea" v-if="isMulp && betForm.length && parlaySelected!=null">
                  <div class="alert">{{ betForm.length }}</div>  
                </div>
              </span>
            </div>
          </div>
          < <div id="mainSection" class="mainSection" :class="{'empty': !oddSelected && !betting.error}">
                  <div class="scroll-content">
                      <template v-if="selectedTab == 'betTab'">
                          <template v-if="!oddSelected && !betting.error">
                              <div id="bettingForm">
                                  <div class="img_order_none"></div>
                                  <div class="betInfo">
                                      <font v-html="betLang['BETTING.LBL_EMPTY_BETSLIP']"></font>
                                  </div>
                              </div>
                          </template>
                          <template v-else>
                              <bettingForm></bettingForm>
                          </template>
                      </template>
                      <template v-else-if="selectedTab == 'betSlipTab'">
                          <betSlipForm></betSlipForm>
                      </template>
                  </div>
          </div> -->
        <!-- </div>
        <div class="bottomArea"></div> -->
    </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex'

  import bettingForm from './bettingForm'
  import betSlipForm from './betSlipForm'
  import eventBus from '@/vue/events/event-bus'

  export default {
    components: {
      bettingForm,
      betSlipForm
    },
    computed: {
      ...mapGetters([
        'account',
        'oddSelected',
        'betting',
        'betLang',
        'isBetSuccess',
        'isPlacedBet',
        'selectedBettype',
        'betForm',
        'parlaySelected',
        'selectedBetListType',
        'pendingFlag',
        'selectedBetTab',
        'openBetForm',
        'showbetformMenu',
        'isParlayTab',
        'bettypeList',
        'previousBettype',
        'isBetCombo',
        'selectedLiveEvent',
        'selectedMatchAllBet',
        'LivetvLang',
        'liveSchedule',
        'tvIconFlag',
        'bettypeFeature',
      ])
    },
    data(){
      return {
        selectedTab: 'betTab',
        last10TimerId: null,
        isMulp: false,
        ttlBetAmount: 0,
        waitingTimer: 60,
        fixTimer: 5,
        // showBetFormMenu: false
        hasParlay:false,
        lang: window.lang,
        allowRbParlay: window.allowRbParlay,
      }
    },
    watch: {
      betForm: {
        handler(val, oldVal) {
          let vue = this
          if(!this.allowRbParlay && this.$store.getters.isBetParlay && val.length == 0 && this.selectedBettype.betTypId != "5") {
            this.$store.commit("IS_BETPARLAY", false);
          }

          if(this.$store.getters.isBetParlay && val.length > 0 && this.selectedBettype.betTypId != "5") {
              this.updateParlay()
          }

          if (this.selectedBettype.betTypId == "5") {
             this.isMulp = true;
             this.hasParlay = true
             if(val.length > 0) {
              this.$store.commit("IS_BETPARLAY", true);
             }
          }else{
             this.isMulp = false;
             this.hasParlay = false
             if(val && val.length>0){
              if(this.isBetCombo){
                var stopLoop = false
                _.forEach(val, function(arr, key) {
                  if(stopLoop) return
                  for (let index = 0; index < vue.$store.getters.eventList.length; index++) {
                    var eid = _.findIndex(vue.$store.getters.eventList[index], (e) => {
                        return e.eveid == arr.eveid;
                    })
                    if(eid>-1){
                        var event = vue.$store.getters.eventList[index][eid]
                        if(event.sptid=='1'){
                          vue.hasParlay = true
                          if(!vue.allowRbParlay && event.rbinfo && event.rbstatus=='1'){
                            vue.hasParlay = false
                            stopLoop = true
                          }
                        } else {
                          if(event.sptid=='2' && event.lgeflag=='0' && !event.rbinfo && event.rbstatus!='1'){
                              vue.hasParlay = true
                          } else {
                            if(vue.hasParlay){
                              vue.hasParlay = false
                              stopLoop = true
                            }
                          }
                        }
                        break;
                    }
                  }
                  for (let index = 0; index < vue.$store.getters.rbeventList.length; index++) {
                    var eid = _.findIndex(vue.$store.getters.rbeventList[index], (e) => {
                        return e.eveid == arr.eveid;
                    })
                    if(eid>-1){
                        var event = vue.$store.getters.rbeventList[index][eid]
                        if(event.sptid=='1'){
                          vue.hasParlay = true
                          if(!vue.allowRbParlay && event.rbinfo && event.rbstatus=='1'){
                            vue.hasParlay = false
                            stopLoop = true
                          }
                        } else {
                          if(vue.hasParlay){
                            vue.hasParlay = false
                            stopLoop = true
                          }
                        }
                        break;
                    }
                  }
                });
              } else {
                // single bet and check has parlay
                var eventId = val[0].eveid
                for (let index = 0; index < vue.$store.getters.eventList.length; index++) {
                  var eid = _.findIndex(vue.$store.getters.eventList[index], (e) => {
                      return e.eveid == eventId;
                  })
                  if(eid>-1){
                      var event = vue.$store.getters.eventList[index][eid]
                      if(event.sptid=='1') {
                        this.hasParlay = true
                        if(!this.allowRbParlay && event.rbinfo && event.rbstatus=='1'){
                          this.hasParlay = false
                        }
                      } else {
                        if(event.sptid=='2' && event.lgeflag=='0' && !event.rbinfo && event.rbstatus!='1'){
                          this.hasParlay = true
                        } 
                      }
                      break;
                  }
                }
                // rb event only soccer allow parlay
                for (let index = 0; index < vue.$store.getters.rbeventList.length; index++) {
                  var eid = _.findIndex(vue.$store.getters.rbeventList[index], (e) => {
                      return e.eveid == eventId;
                  })
                  if(eid>-1){
                      var event = vue.$store.getters.rbeventList[index][eid]
                      if(event.sptid=='1'){
                        this.hasParlay = true
                        if(!this.allowRbParlay && event.rbinfo && event.rbstatus=='1'){
                          this.hasParlay = false
                        }
                      } 
                      break;
                  }
                }
              }
             }
          }

          if (this.bettypeFeature && this.bettypeFeature.includes('15')) {
            this.hasParlay = false;
          }
          // if (this.betForm.length>0) {
          //    this.openBetForm = true;
          // }
        }
      },
    },
    methods : {
      openLivetv(){
        if(!this.$store.getters.account.previewFlag || this.$store.getters.isLiveOn){
          this.$store.commit("LIVE_SCHECULE", true)
          this.$store.commit('OPEN_RBMARKET', false)
          this.$store.commit("GAMEBANNER_SELECTED", false)
          this.$store.commit('SELECTED_ALLBET', false)
          this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
          this.$store.commit('SELECTED_MATCHALLBET', true)

          if($('.menu-fold2-wrap').hasClass('open')){
            $('.menu-fold2-wrap').removeClass('open')
          }

          eventBus.$emit('callLivetv')
        } else if (window._hasRedirect) {
          $('.login-redirect-dialog').show();
        }
      },
      toggleBetForm(){
        this.$store.commit("OPEN_BETFORM", true)
        this.$store.commit("ODD_SELECTED", true);
        this.$store.commit('SELECTED_TAB', 'betSlipTab')
        this.$store.commit("SHOW_BETFORM_MENU", false);
        
        //if success retain selection
        this.$store.dispatch("getBettingInfo", {
          isRetainSel: (this.$store.getters.betting.success || this.$store.getters.betting.betcombosuccess) ? true : false,
          callback: ((res) => {
            this.$store.commit("SPORT_MAPPING_BETTING", {
              newBettingList: res.SYSTEM_DATA.betting,
              oldBettingList: this.$store.getters.betForm,
            });
          }).bind(this),
        });
      },
      backMenu(){
        this.selectedTab = 'betTab';
        this.$store.commit("ODD_SELECTED", false);
        this.$store.commit("OPEN_BETFORM", false);
        this.$store.commit("SELECTED_BETTAB", false);
        this.$store.commit('SELECTED_TAB', 'betTab')
        this.$store.commit("SPORT_MINIBET_BETAMOUNT", 0);
        this.$store.commit('BETTING_MESSAGE', { isError: false }) //clear betting success/reject/pending/combosuccess
        eventBus.$emit('stopBettingTimer')
        
        if(this.betForm.length>0){
          this.$store.commit("SHOW_BETFORM_MENU", true);
        }
      },
      changeTab(tab) {
        var mini = $('.sidebar-first').hasClass('mini')

        this.$store.getters.oddSelected && this.$store.commit("ODD_SELECTED", false);
        this.$store.getters.openBetForm && this.$store.commit("OPEN_BETFORM", false);
        this.$store.getters.showbetformMenu && this.$store.commit("SHOW_BETFORM_MENU", false);
        
        if(!this.account.previewFlag){
          this.selectedTab = tab;
          this.$store.commit('SELECTED_TAB', tab)
          if(this.selectedTab == 'betSlipTab') {
            var isBetSlip =(!this.oddSelected && this.showBetFormMenu)
            // $('.item-bet').addClass('hidden')
            
            this.getLast10Bets()
            // this.changeBetSlipType(this.selectedBetListType)
           // this.$store.commit('ODD_SELECTED', false)

            var active = $('.betList').hasClass('active')
            var collapsed = $('.betList').hasClass('collapsed')

            if(mini){
              // $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
              // $('.widgetArea').find('.scroll-panel').find('.expendScore').css('width', '40em');
             // $('.widgetArea').find('.mainSection').find('.scroll-content').css('width', '');
            }

            if(active){
              if(!isBetSlip){
                this.$store.commit('SELECTED_BETTAB', false)
                // $('.betList').addClass('collapsed')
                $('.sportsMenu').removeClass('collapsed')
              }
            }else if(collapsed){
              // $('.betList').removeClass('collapsed')
              // $('.betList').addClass('active')
              this.$store.commit('SELECTED_BETTAB', true)
              $('.sportsMenu').addClass('collapsed')
            }else{
              this.$store.commit('SELECTED_BETTAB', true)
              if(mini){ // fix mini
                $('.betList').addClass('active')
              }
            }
          }else{
            var isBetList = $('.widgetPanel.group').hasClass('betList')

            $('.widgetPanel.group').removeClass('betList')
            $('.widgetPanel.group').addClass('betSlip')
            this.$store.commit('BET_SUCCESS', false)

            var active = $('.betSlip').hasClass('active')
            var collapsed = $('.betSlip').hasClass('collapsed')
            
            $('.item-bet').removeClass('hidden')
            if(mini){
              // $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
              // $('.widgetArea').find('.scroll-panel').find('.expendScore').css('width', '40em');
             // $('.widgetArea').find('.mainSection').find('.scroll-content').css('width', '');
            }
            if(active){
              if(!isBetList){
                this.$store.commit('SELECTED_BETTAB', false)
                // $('.betSlip').addClass('collapsed')
                $('.sportsMenu').removeClass('collapsed')
              }
            }else if(collapsed){
              // $('.betSlip').removeClass('collapsed')
              // $('.betSlip').addClass('active')
              this.$store.commit('SELECTED_BETTAB', true)
              $('.sportsMenu').addClass('collapsed')
            }else{
              if(mini){ // fix mini
                $('.betSlip').addClass('active')
              }
            }
          }
        } else if (window._hasRedirect) {
          $('.login-redirect-dialog').show();
        }
      },
     CountbetTimer() {
        if(this.pendingTimerId == null){
          this.pendingTimerId = setInterval((() => {
            if(this.waitingTimer - 1 < 0){
              this.waitingTimer = this.fixTimer
                eventBus.$emit('ttlbetCount')
            }else{
              this.waitingTimer -= 1
            }
          }).bind(this),1000);
        }
      },
      getLast10Bets() {
        eventBus.$emit('reloadingLast10Wager', true)
        this.$store.dispatch('getLast10Wager',{
          token: token.arr_2,
          last10Wager: true,
          novaWager: this.selectedBetListType,
          callback: ((res)=> {
            // this.ttlBetAmount = res.wagerList.total;
            eventBus.$emit('reloadingLast10Wager', false)
          }).bind(this)
        })
      },
      getCountBet() {
      //  eventBus.$emit('reloadingLast10Wager', true)
        this.$store.dispatch('getLast10Wager',{
          token: token.arr_2,
          last10Wager: true,
          isCount: true,
          wgrTyp: 'openBet',
          // novaWager: this.selectedBetListType,
          callback: ((res)=> {
            this.ttlBetAmount = res.count;
        //    eventBus.$emit('reloadingLast10Wager', false)
          }).bind(this)
        })
      },
      closeTab() {
        var betSlipAct = $('.betSlip').hasClass('active')
        var betListAct = $('.betList').hasClass('active')

        if(betSlipAct || betListAct){
          // $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
          // $('.widgetArea').find('.scroll-panel').find('.scroll-content').css('width', '');
        }

        $('.widgetPanel.group').removeClass('active')
      },
      confirmBetSlip(tab) {

        this.selectedTab = tab;
        this.$store.commit('SELECTED_TAB', tab)
        this.$store.commit('PLACED_BET', true)
        if(this.selectedTab == 'betSlipTab') {
          this.getLast10Bets()
          this.$store.commit('ODD_SELECTED', false)

          this.changeTab(this.selectedTab)

          // this.changeTab(this.selectedTab)
          // console.log('kdkdkd')
          // $('.betList').addClass('active')
          // $('.sportsMenu').addClass('collapsed')

          // $('.widgetPanel.group').removeClass('collapsed')
          // $('.widgetPanel.group').removeClass('betSlip')
          // $('.widgetPanel.group').addClass('betList')
          // $('.widgetPanel.group').addClass('active')
          // $('.sportsMenu').addClass('collapsed')
        }
      },
      changeBetSlipType (type) {
        this.$store.commit('PENDING_FLAG', false)
        this.$store.commit('BETLIST_TYPE', type)
        this.getLast10Bets();
        /*
        if(this.last10TimerId == null){
          this.last10TimerId = setInterval((() => {
            this.getLast10Bets()
          }).bind(this), 10000)
        }*/
      },
      updateParlay(clickParlayButton=false){
        if(this.betting.pending || this.betting.success || this.betting.betcombosuccess || this.betting.reject){
          // reset betting message
          this.$store.commit('BETTING_MESSAGE', { isError: false });
          this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });
          // clear input
          this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
          this.$store.commit("BETMULP_AMOUNT", {resetBetMulpAmount: true});
          this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
          var arr = { clear: true }
          this.$store.commit("BETCOMBO_AMOUNT", arr);
          eventBus.$emit('clearAllBetComboAmount');
          this.$store.commit('ODD_SELECTED', true)
          eventBus.$emit('stopBettingTimer');
          this.$store.commit('SET_MATCH_INDEX_NO_ERR', [])
        }
        if(clickParlayButton) {
          this.$store.commit("BETMULP_AMOUNT", {resetBetMulpAmount: true});
          this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
        }
        if(this.selectedBettype!=undefined && this.selectedBettype.betTypId=='5'){ // unset mulp
          this.$store.commit("IS_BETPARLAY", false);
          this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.previousBettype.bettype))
          this.$store.commit("IS_BETCOMBO", this.previousBettype.isBetCombo);
          this.$store.commit('PREV_BETTYPE', null)
          // if not combo remove extra matches
          if(!this.isBetCombo && this.betForm.length>1){
            this.$store.dispatch("removeMatch", {
              data: {clearType: '2'},
            });
          }
        } else { // set mulp
          this.$store.commit("IS_BETPARLAY", true);
          this.$store.commit('PREV_BETTYPE', {bettype:this.selectedBettype, isBetCombo:this.isBetCombo})
          var bettyp_index = _.findIndex(this.bettypeList, function(value,id) {
              return value.betTypId == '5';
          });
          if(bettyp_index > -1) {
            this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.bettypeList[bettyp_index]))
          }
          this.$store.commit("IS_BETCOMBO", false);
        }
        if(clickParlayButton) {
          this.$store.dispatch("getBettingInfo", {
            callback: ((res) => {
              this.$store.commit("SPORT_MAPPING_BETTING", {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBettingList: this.$store.getters.betForm,
              });
              // this.refreshTimer();
              // this.isReloading = false;
            }).bind(this),
          });
        }
      },
    },
    mounted() {
      eventBus.$on('showBetslip', ((show)=> {
        // this.$store.commit('SELECTED_TAB', 'betTab')
        this.selectedTab = 'betTab'
      }).bind(this))
      
      eventBus.$on('returnBetTab', ((show)=> {
        // this.$store.commit('SELECTED_TAB', 'betTab')
        this.selectedTab = 'betTab'
      }).bind(this))

      eventBus.$on('confirmBetSlip', (tab) => {
        this.confirmBetSlip(tab)
      })

      eventBus.$on('upWaitStatus', () => {
        this.changeBetSlipType(this.selectedBetListType)
      })

      eventBus.$on('ttlbetCount', (tab) => {
        this.getCountBet()
      })
      eventBus.$emit('ttlbetCount')
    },
    beforeMount(){
      
      this.CountbetTimer()
    },
    beforeDestroy() {
      eventBus.$off('showBetslip')
      eventBus.$off('upWaitStatus')
      eventBus.$off('stopBettingTimer')
      eventBus.$off('returnBetTab')
      eventBus.$off('ttlbetCount')
    },
    updated() {
      this.selectedBetType = this.selectedBettype.betTypId
    }
  }
</script>


// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/mainB.vue